import { PrintEngineRecommendationDismissal } from "@redotech/redo-fulfillment-group-common/print-engine";
import * as z from "zod";

export const dismissPrintEngineRecommendation = {
  name: "dismissPrintEngineRecommendation" as const,
  input: z.object({
    computerId: z.number(),
    dismissal: z.enum(PrintEngineRecommendationDismissal),
  }),
  output: z.void(),
};
